export const ARC_EVENTS = {
    accessibilityChange: 'arc-accessibility-change',
    afterHide: 'arc-after-hide',
    afterShow: 'arc-after-show',
    auth: 'arc-auth',
    change: 'arc-change',
    error: 'arc-error',
    hide: 'arc-hide',
    initialFocus: 'arc-initial-focus',
    loaded: 'arc-loaded',
    requestClose: 'arc-request-close',
    select: 'arc-select',
    showAccessibility: 'arc-show-accessibility',
    show: 'arc-show',
};
